module.exports = __webpack_public_path__ + "media/images/logos/mrzen-logo-full-f36205605e9d802b4b8a5feda457c460.svg";